import { React, useState } from 'react';

import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import AssignmentTurnedInRoundedIcon from '@mui/icons-material/AssignmentTurnedInRounded';
import FactCheckRoundedIcon from '@mui/icons-material/FactCheckRounded';
import SendRoundedIcon from '@mui/icons-material/SendRounded';
import TableChartRoundedIcon from '@mui/icons-material/TableChartRounded';
import UploadFileRoundedIcon from '@mui/icons-material/UploadFileRounded';

import { Alerta } from '../components/alerta';
import SubmitButton from '../components/submitButton';
import { fetchFlask } from '../utils/fetchFlask';

const InserirGeracaoBulk = () => {
    const [arquivo, setArquivo] = useState(null);
    const [message, setMessage] = useState('');
    const [status, setStatus] = useState('');
    const [openAlerta, setOpenAlerta] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);

    async function atualizarGeracaoBulk (e) {
        e.preventDefault();
        setIsSubmit(true);

        const formData = new FormData();
        formData.append('arquivoCSV', arquivo);

        try {
            const response = await fetchFlask('atualizarGeracaoBulk', formData);
            handleAlerta(response);
            if (response.status === 'success') {
                setArquivo(null);
            }
        } finally {
            setIsSubmit(false);
        }
    }

    function handleAlerta (response) {
        setMessage(response.message);
        setStatus(response.status);
        setOpenAlerta(true);
    }

    const completedFields = [arquivo].filter(Boolean).length;

    return (
        <>

            <Alerta
                texto={message}
                status={status}
                open={openAlerta}
                handleClose={() => setOpenAlerta(false)}
            />

            <form action='' method='POST' id='formGeracaoBulk' onSubmit={atualizarGeracaoBulk} className='generation-entry-layout'>
                <Box className='generation-entry-workspace'>
                    <Box className='generation-entry-intro'>
                        <Box>
                            <h2>Importação de geração por CSV</h2>
                        </Box>
                        <p>
                            Envie um arquivo no formato data, serial e geração para atualizar múltiplos registros.
                        </p>
                    </Box>

                    <Box className='generation-entry-panel'>
                        <Box className='generation-entry-section-heading'>
                            <UploadFileRoundedIcon />
                            <Box>
                                <span>Etapa única</span>
                                <strong>Arquivo CSV</strong>
                            </Box>
                        </Box>

                        <Box className='generation-entry-file-strip'>
                            <TableChartRoundedIcon />
                            <TextField
                                type='file'
                                size='small'
                                inputProps={{ accept: '*/*' }}
                                onChange={(e) => setArquivo(e.target.files[0])}
                            />
                        </Box>

                        <Box className='generation-entry-format-note'>
                            <strong>Formato esperado</strong>
                            <span>dd/mm/YYYY | Serial | Geração</span>
                        </Box>
                    </Box>
                </Box>

                <Box className='generation-entry-summary'>
                    <Box className='generation-entry-summary-header'>
                        <FactCheckRoundedIcon />
                        <Box>
                            <span>Resumo</span>
                            <strong>Revisão do envio</strong>
                        </Box>
                    </Box>

                    <Box className='generation-entry-summary-list'>
                        <Box>
                            <span>Arquivo</span>
                            <strong className={!arquivo ? 'is-empty' : undefined}>{arquivo?.name || 'Não selecionado'}</strong>
                        </Box>
                        <Box>
                            <span>Modo</span>
                            <strong>Importação CSV</strong>
                        </Box>
                    </Box>

                    <Box className='generation-entry-attention'>
                        <UploadFileRoundedIcon />
                        <p>
                            Revise o arquivo antes de enviar. O lote será processado conforme o conteúdo do CSV selecionado.
                        </p>
                    </Box>

                    <Box className='generation-entry-completion'>
                        <AssignmentTurnedInRoundedIcon />
                        <Box>
                            <span>Campos críticos</span>
                            <strong>{completedFields}/1 preenchido</strong>
                        </Box>
                    </Box>

                    <SubmitButton isSubmit={isSubmit} startIcon={<SendRoundedIcon />}>
                        Enviar CSV
                    </SubmitButton>
                </Box>
            </form>
        </>
    );
};

export default InserirGeracaoBulk;
